<div [formGroup]="parentForm" *ngIf="patient">
<div class="patient-fields">

            <div class="patient-fields-block">
              <div class="field-row name-dob-row">
                  <div class="item flex-name">
                    <mat-form-field [hideRequiredMarker]="false">
                      <mat-label>FIRST NAME</mat-label>
                      <input matInput type="text" formControlName="firstName" [ngClass]="{'has-error':parentForm.get('firstName').invalid}" class="bigfont" autocomplete="off" required>

                      <mat-error *ngIf="parentForm.get('firstName').invalid">FIRST NAME IS REQUIRED</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="item flex-name">
                    <mat-form-field [hideRequiredMarker]="false">
                      <mat-label>LAST NAME</mat-label>
                      <input matInput type="text" formControlName="lastName" [ngClass]="{'has-error':parentForm.get('lastName').invalid}" class="bigfont" autocomplete="off" required>
                      <mat-error *ngIf="parentForm.get('lastName').invalid">LAST NAME IS REQUIRED</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="item flex-prefix">
                    <mat-form-field>
                      <mat-label>PREFIX</mat-label>
                      <mat-select formControlName="prefix">
                        <mat-option value="">-</mat-option>
                        <mat-option value="MR">MR</mat-option>
                        <mat-option value="MRS">MRS</mat-option>
                        <mat-option value="MS">MS</mat-option>
                        <mat-option value="MX">MX</mat-option>
                        <mat-option value="MISS">MISS</mat-option>
                        <mat-option value="MSTR">MSTR</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="item flex-dob">
                    <mat-form-field class="date">
                      <mat-label>DATE OF BIRTH</mat-label>
                      <input matInput [matDatepicker]="dob" (blur)="blurDate()" formControlName="dob" autocomplete="off">
                      <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                      <mat-datepicker #dob></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

              <div class="field-row">
                  <div class="item flex-grow">
                    <mat-form-field>
                      <mat-label>ADDRESS</mat-label>
                      <input matInput type="text" formControlName="address" autocomplete="off">
                    </mat-form-field>
                  </div>
                </div>

              <div class="field-row">
                  <div class="item flex-city">
                    <mat-form-field>
                      <mat-label>CITY</mat-label>
                      <input matInput type="text" formControlName="city" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item flex-state">
                    <mat-form-field>
                      <mat-label>STATE</mat-label>
                      <input matInput aria-label="STATE" [matAutocomplete]="auto" (change)="updateState($event)" [formControl]="stateCtrl" formControlName="state" autocomplete="off">
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let state of filteredStates | async" [value]="state.abbreviation">
                          <span>{{ state.abbreviation }} - {{ state.name }}</span>
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                  <div class="item flex-zip">
                    <mat-form-field>
                      <mat-label>ZIP</mat-label>
                      <input matInput type="text" formControlName="zip" autocomplete="off">
                    </mat-form-field>
                  </div>
                </div>

              <div class="field-row single-line-row">
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <mat-label>HOME PHONE</mat-label>
                      <input matInput class="bigfont" type="tel" formControlName="phone" autocomplete="off" mask="(000)000-0000 x9999" [specialCharacters]="[ ' ', '(', ')', '-', 'x' ]">
                    </mat-form-field>
                  </div>
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <mat-label>WORK PHONE</mat-label>
                      <input matInput class="bigfont" type="tel" formControlName="phone2"  mask="(000) 000-0000 x9999" [specialCharacters]="[ ' ', '(', ')', '-', 'x' ]" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <mat-label>CELL PHONE</mat-label>
                      <input matInput class="bigfont" type="tel" formControlName="cell"  mask="(000) 000-0000 x9999" [specialCharacters]="[ ' ', '(', ')', '-', 'x' ]" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <mat-label>EMAIL</mat-label>
                      <input matInput type="email" formControlName="email" autocomplete="off">
                    </mat-form-field>
                    <div class="alert alert-danger" *ngIf="0">A valid email is required.</div>
                  </div>
                </div>
            </div>

            <div class="patient-fields-block">
              <div class="field-split field-split-match">
                <div class="field-stack">
                  <div class="item">
                    <mat-form-field>
                      <mat-label>OCCUPATION</mat-label>
                      <input matInput type="text" formControlName="occupation" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item">
                    <mat-form-field>
                      <mat-label>INTERESTS</mat-label>
                      <input matInput type="text" formControlName="interests" autocomplete="off">
                    </mat-form-field>
                  </div>
                </div>
                <div class="item field-match-side">
                  <mat-form-field class="textarea-match">
                    <mat-label>FAMILY MEMBERS</mat-label>
                    <textarea matInput formControlName="familyMembers" rows="3" autocomplete="off"></textarea>
                  </mat-form-field>
                </div>
              </div>

              <div class="field-row">
                <div class="item flex-grow">
                  <mat-form-field>
                    <mat-label>HOW DID YOU FIND US?</mat-label>
                    <mat-select formControlName="howDidYouFindUs" autocomplete="off">
                      <mat-option *ngFor="let howDidYouFindUsType of howDidYouFindUsTypes" [(value)]="howDidYouFindUsType.value">
                      {{ howDidYouFindUsType.viewValue }}
                    </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="item flex-grow" *ngIf="parentForm.get('howDidYouFindUs').value=='OTHER'">
                  <mat-form-field>
                    <mat-label>OTHER</mat-label>
                    <input matInput type="text" [(value)]="parentForm.value.howDidYouFindUsOther" formControlName="howDidYouFindUsOther" autocomplete="off">
                  </mat-form-field>
                </div>
              </div>
            </div>
</div>

            <div class="patient-summary-bar">
              <div class="patient-summary-item">
                <mat-form-field class="date">
                  <mat-label>LAST EXAM</mat-label>
                  <input matInput [matDatepicker]="pickerLastExam" formControlName="lastExam">
                  <mat-datepicker-toggle matSuffix [for]="pickerLastExam"></mat-datepicker-toggle>
                  <mat-datepicker #pickerLastExam></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="patient-summary-item">
                <mat-form-field>
                  <mat-label>AVAILABLE CREDIT</mat-label>
                  <input matInput type="text" formControlName="storeCredit" (blur)="formatCurrency($event,parentForm.controls.storeCredit)" autocomplete="off">
                  <span matPrefix>$&nbsp;</span>
                </mat-form-field>
              </div>
            </div>
    </div>
